export default "__VITE_ASSET__DfNtNynx__"